// extracted by mini-css-extract-plugin
export default {"GraphDataExport":"GraphDataExportLight__GraphDataExport___KQfaM"};